import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import successJson from '../../animations/success.json';
import { SemanticColor, semanticColorsV1 } from '../../theme/colors';
import { LottieAnimationViewV1 } from './LottieAnimationViewV1';

/** v1 design of success animation (as in master): `success.json` recolored with `IconEmphasised`. Rendered for widgets without `version: 2`. */
export const SuccessAnimationV1 = ({ widget }: TWidgetProps<TCommonData>) => {
    return (
        <LottieAnimationViewV1
            dataTest={widget.uid}
            animationData={successJson}
            animationsColor={semanticColorsV1[SemanticColor.IconEmphasised]}
            loop={false}
            size="73px"
            margin={widget.options?.margin}
        />
    );
};
